const initContentListSlider = () => {

  jQuery( '.module--content-list .content-list-slider' ).each( ( index, single ) => {

    const numOfSilders = jQuery( single ).attr( 'data-col' );

    jQuery( single ).slick({
      arrows:         true,
      dots:           false,
      slidesToShow:   numOfSilders,
      slidesToScroll: 1,
      infinite:       true,
      responsive:     [
        {
          breakpoint: 1279,
          settings:   {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings:   {
            slidesToShow: 1
          }
        }
      ],
    });

    jQuery( single ).removeClass( 'hide' );

  });

};

jQuery( () => {
  initContentListSlider();
});
